import { ILegScanProps } from "../../../../../../../@types/components/legScanDetailsprops.types";
import { displayValue } from "../../../../../../../utils/commonFunctions/displayValue";
import "./ScanDetailsSections.css";

const formatScanDate = (date: unknown): string => {
	if (!date) return "—";
	const parsed = new Date(date as string);
	if (isNaN(parsed.getTime())) return "—";
	return parsed.toLocaleString();
};

const ScanHeaderInfo = ({ legScan }: ILegScanProps) => {
	const customerName = legScan.customer
		? `${legScan.customer.first_name} ${legScan.customer.last_name}`
		: legScan.customer_id;

	return (
		<div className="scan-header-info">
			<div className="scan-header-info-item">
				<p className="scan-header-info-label">Customer</p>
				<p className="scan-header-info-value">{displayValue(customerName)}</p>
			</div>
			<div className="scan-header-info-item">
				<p className="scan-header-info-label">Shop / Store</p>
				<p className="scan-header-info-value">{displayValue(legScan.store_name)}</p>
			</div>
			<div className="scan-header-info-item">
				<p className="scan-header-info-label">Scan Date</p>
				<p className="scan-header-info-value">{formatScanDate(legScan.date)}</p>
			</div>
			<div className="scan-header-info-item">
				<p className="scan-header-info-label">Scanner No</p>
				<p className="scan-header-info-value">{displayValue(legScan.device_id)}</p>
			</div>
			<div className="scan-header-info-item">
				<p className="scan-header-info-label">Age</p>
				<p className="scan-header-info-value">
					{displayValue(legScan.device_age || legScan.customer?.age_range)}
				</p>
			</div>
			<div className="scan-header-info-item">
				<p className="scan-header-info-label">Gender</p>
				<p className="scan-header-info-value">{displayValue(legScan.customer?.gender)}</p>
			</div>
		</div>
	);
};

export default ScanHeaderInfo;
